"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePopper = void 0;
var _react = require("react");
var _reactPopper = require("react-popper");
var _useSpacingValue = require("../../hooks/useSpacingValue");
const usePopper = ({
  placement,
  skid,
  gap,
  offsetGap
}) => {
  const _useState = (0, _react.useState)(null),
    subject = _useState[0],
    setSubject = _useState[1];
  const _useState2 = (0, _react.useState)(null),
    popper = _useState2[0],
    setPopper = _useState2[1];
  const calculatedSkid = (0, _useSpacingValue.useSpacingValue)(skid !== null && skid !== void 0 ? skid : 0);
  const calculatedGap = (0, _useSpacingValue.useSpacingValue)(gap !== null && gap !== void 0 ? gap : 0);
  const getOffsetGap = offsetGap && calculatedGap - offsetGap;
  const popperOptions = (0, _react.useMemo)(() => {
    return {
      placement,
      modifiers: [{
        name: 'offset',
        options: {
          offset: [calculatedSkid, getOffsetGap !== null && getOffsetGap !== void 0 ? getOffsetGap : calculatedGap]
        }
      }]
    };
  }, [placement, calculatedSkid, getOffsetGap, calculatedGap]);
  const _useExternalPopper = (0, _reactPopper.usePopper)(subject, popper, popperOptions),
    popperStyles = _useExternalPopper.styles,
    popperAttributes = _useExternalPopper.attributes;
  return {
    popper,
    subject,
    setSubject,
    setPopper,
    popperStyles,
    popperAttributes
  };
};
exports.usePopper = usePopper;